import type { FC } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import type { ChangelogFeature, ChangelogFix } from '../types'
import {
  whatsNewChangelogDescriptionSx,
  whatsNewChangelogIdSx,
  whatsNewChangelogItemSx,
  whatsNewChangelogTitleSx,
} from '../whatsNewModalStyles'

type ChangelogItemProps = {
  item: ChangelogFeature | ChangelogFix
  kind: 'feature' | 'fix'
}

export const ChangelogItem: FC<ChangelogItemProps> = ({ item, kind }) => {
  const isFeature = kind === 'feature'

  return (
    <Box sx={whatsNewChangelogItemSx(isFeature)}>
      <Typography component="span" sx={whatsNewChangelogIdSx(isFeature)}>
        {item.id}
      </Typography>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={whatsNewChangelogTitleSx}>{item.title}</Typography>
        {item.description && (
          <Typography sx={whatsNewChangelogDescriptionSx}>
            {item.description}
          </Typography>
        )}
      </Box>
    </Box>
  )
}
